import { render, staticRenderFns } from "./vehicle-transferl-modal.vue?vue&type=template&id=33cedf80&scoped=true"
import script from "./vehicle-transferl-modal.vue?vue&type=script&lang=js"
export * from "./vehicle-transferl-modal.vue?vue&type=script&lang=js"
import style0 from "./vehicle-transferl-modal.vue?vue&type=style&index=0&id=33cedf80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cedf80",
  null
  
)

export default component.exports